<div>
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()" [rows]="removedVolunteers()"></grid-content>
</div>